import * as React from 'react'
import { FC } from 'react'
import Tabs from '@mui/material/Tabs'
import { AddServiceLocationFormProps } from './typings'
import { Tab, TabPanel } from '@sales-center/components'
import { AddServiceLocationForm } from './AddServiceLocationForm'
import Box from '@mui/material/Box'
import { AddExistingServiceLocationFormWrapper } from './AddExistingServiceLocationFormWrapper'

const styles = {
  indicator: {
    backgroundColor: '#005AA3',
  },

  selectedTab: {
    color: '#005AA3',
  },

  backGroundGray: {
    backgroundColor: '#f9f9f9',
  },
}

export const ServiceLocationTabs: FC<AddServiceLocationFormProps> = (props) => {
  const { matched } = props
  const [newServiceLocation, setValue] = React.useState(matched ? 1 : 0)

  const handleChange = React.useCallback((_event, newValue: number) => {
    setValue(newValue)
  }, [])

  return (
    <>
      <Box sx={styles.backGroundGray}>
        <Tabs
          sx={{ indicator: styles.indicator }}
          variant="fullWidth"
          onChange={handleChange}
          value={newServiceLocation}
          TabIndicatorProps={{ style: { width: '270px' } }}
        >
          <Tab
            sx={{ selected: styles.selectedTab }}
            label="Add Existing Service Location"
            value={1}
            data-test-id="addExistingServiceLocationTab"
          />
          <Tab
            sx={{ selected: styles.selectedTab }}
            label="Add New Service Location"
            value={0}
            data-test-id="addNewServiceLocationTab"
          />
        </Tabs>
      </Box>
      <TabPanel
        value={0}
        tab={newServiceLocation}
        style={{ overflowY: 'scroll' }}
      >
        <AddServiceLocationForm {...props} />
      </TabPanel>
      <TabPanel
        value={1}
        tab={newServiceLocation}
        style={{ overflowY: 'scroll' }}
      >
        <AddExistingServiceLocationFormWrapper {...props} />
      </TabPanel>
    </>
  )
}
